import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer id="site-footer" className="site-footer footer-v1 about-v4">
    <div className="overlay overlay-image"></div>
        <div className="container">
            
            <div className="row">
                
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="widget-footer">
                        <h5 className="text-white">Services</h5>
                        <ul className="list-items">
                            <li className="list-item"><Link to="/services">Web Development</Link></li>
                            <li className="list-item"><Link to="/services">Mobile Development</Link></li>
                            <li className="list-item"><Link to="/services">IT Services</Link></li>
                            <li className="list-item"><Link to="/services">iOS & Android</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="widget-footer">
                        <h5 className="text-white">Learn</h5>
                        <ul className="list-items">
                            <li className="list-item"><Link to="">Social Media Platform</Link></li>
                            <li className="list-item"><Link to="">Business Management Tools</Link></li>
                            <li className="list-item"><Link to="">Sports and Fitness App</Link></li>
                            <li className="list-item"><Link to="">Software as a Service (SaaS)</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="widget-footer">
                        <h5 className="text-white">Company</h5>
                        <ul className="list-items">
                            <li className="list-item"><Link to="/about">About Company</Link></li>
                            <li className="list-item"><Link to="">For Customers</Link></li>
                            <li className="list-item"><Link to="blogs">Blog & News</Link></li>
                            <li className="list-item"><Link to="">Careers & Reviews</Link></li>
                            <li className="list-item"><Link to="">Sitemap</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="widget-footer">
                        <h5 className="text-white">Subscribe</h5>
                        <p>Follow our newsletter to stay updated  about agency.</p>
                        <form action="newsletter.php" id="mc4wp-form-1" className="mc4wp-form" method="post">
                            <div className="mc4wp-form-fields">
                                <div className="subscribe-inner-form">
                                    <input type="email" name="email" placeholder="Your Email" />
                                    <button type="submit" className="subscribe-btn-icon"><i className="flaticon-telegram"></i></button>
                                </div>  
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="row mt-35">
                <div className="col-md-4 mb-4 mb-md-0">
                    <img src={require("../images/1logo/logo2.png")} alt="" className="lazyloaded" data-ll-status="loaded"/>
                </div>
                <div className="col-md-8 text-left text-md-right align-self-center">
                    <p className="copyright-text">Copyright © {currentYear} Swift Panther. All Rights Reserved.</p>
                </div>
            </div>
        </div>

</footer>
  )
}

export default Footer